export default __webpack_public_path__ + "static/fb-editorial-vegan-aa62d49e0d82dd9a0e16101a3ffeed21.jpg";